export default __webpack_public_path__ + "static/media/38_LY.eb31f3a4.png";